import { colors } from '@material-ui/core'
import {
  AlertTriangle as AlertTriangleIcon,
  CheckCircle as CheckCircleIcon,
  Clock as ClockIcon,
  MessageCircle as MessageCircleIcon,
  XCircle as XCircleIcon,
} from 'react-feather'

import theme from 'theme'

const NEW_STATUS_ID = 1
const PENDING_STATUS_ID = 2
const COMPLETED_STATUS_ID = 3
const CANCELED_STATUS_ID = 4
const AWAITING_CONFIRMATION_STATUS_ID = 5
const AWAITING_CONFIRMATION_LEGITIMACY_STATUS_ID = 6
const AWAITING_CONFIRMATION_IDENTITY_STATUS_ID = 7
const AWAITING_COMPANY_REPLY_STATUS_ID = 8
const AWAITING_REPLY_VALIDATION_STATUS_ID = 9
const REPLIED_STATUS_ID = 10
const REOPEN_STATUS_ID = 11

const NEW_STATUS_LABEL = 'Novo'
const PENDING_STATUS_LABEL = 'Pendente'
const COMPLETED_STATUS_LABEL = 'Concluído'
const CANCELED_STATUS_LABEL = 'Cancelado'
const AWAITING_CONFIRMATION_STATUS_LABEL = 'Aguardando Confirmação'
const AWAITING_CONFIRMATION_LEGITIMACY_STATUS_LABEL =
  'Aguardando Aprovação da Solicitação'
const AWAITING_CONFIRMATION_IDENTITY_STATUS_LABEL =
  'Pendente de Confirmação de Identidade'
const AWAITING_COMPANY_REPLY_STATUS_LABEL = 'Aguardando Resposta da Empresa'
const AWAITING_REPLY_VALIDATION_STATUS_LABEL = 'Validar Resposta'
const REPLIED_STATUS_LABEL = 'Respondido'
const REOPEN_STATUS_LABEL = 'Reaberto'

const NEW_STATUS_LABEL_ID = 'new'
const PENDING_STATUS_LABEL_ID = 'pending'
const COMPLETED_STATUS_LABEL_ID = 'completed'
const CANCELED_STATUS_LABEL_ID = 'canceled'
const AWAITING_CONFIRMATION_STATUS_LABEL_ID = 'awaiting_confirmation'
const AWAITING_COMPANY_REPLY_STATUS_LABEL_ID = 'awaiting_company_reply'
const AWAITING_REPLY_VALIDATION_STATUS_LABEL_ID = 'awaiting_reply_validation'
const REPLIED_STATUS_LABEL_ID = 'replied'
const REOPEN_STATUS_LABEL_ID = 'reopen'

const PENDING_COMPANY_STATUS_ID = 'pending'
const REPLIED_COMPANY_STATUS_ID = 'replied'
const OVERDUE_COMPANY_STATUS_ID = 'overdue'
const CANCELED_COMPANY_STATUS_ID = 'canceled'
const FINALIZED_COMPANY_STATUS_ID = 'finalized'

const PENDING_COMPANY_STATUS_LABEL = 'Pendente'
const REPLIED_COMPANY_STATUS_LABEL = 'Respondido'
const OVERDUE_COMPANY_STATUS_LABEL = 'Atrasado'
const CANCELED_COMPANY_STATUS_LABEL = 'Cancelado'
const FINALIZED_COMPANY_STATUS_LABEL = 'Finalizado'

const JURIDIC_TICKET_TYPE = 'juridic'
const SECURITY_TICKET_TYPE = 'security'

const TICKET_TYPE = { JURIDIC_TICKET_TYPE, SECURITY_TICKET_TYPE }

const MESSAGE_SYSTEM_AUTHOR = 'Sistema'

const STATUS_CHIP_CLASSNAME_FROM_LABELS = {
  [NEW_STATUS_LABEL]: NEW_STATUS_LABEL_ID,
  [PENDING_STATUS_LABEL]: PENDING_STATUS_LABEL_ID,
  [COMPLETED_STATUS_LABEL]: COMPLETED_STATUS_LABEL_ID,
  [CANCELED_STATUS_LABEL]: CANCELED_STATUS_LABEL_ID,
  [AWAITING_CONFIRMATION_STATUS_LABEL]: AWAITING_CONFIRMATION_STATUS_LABEL_ID,
  [AWAITING_COMPANY_REPLY_STATUS_LABEL]: AWAITING_COMPANY_REPLY_STATUS_LABEL_ID,
  [AWAITING_REPLY_VALIDATION_STATUS_LABEL]:
    AWAITING_REPLY_VALIDATION_STATUS_LABEL_ID,
  [REPLIED_STATUS_LABEL]: REPLIED_STATUS_LABEL_ID,
  [REOPEN_STATUS_LABEL]: REOPEN_STATUS_LABEL_ID,
}

const TITULAR_STATS_CARD_ITEMS = [
  {
    id: PENDING_STATUS_ID,
    status: PENDING_COMPANY_STATUS_ID,
    subTitle: PENDING_COMPANY_STATUS_LABEL,
    Icon: ClockIcon,
    iconBgColor: colors.blue[700],
  },
  {
    id: REPLIED_STATUS_ID,
    status: REPLIED_COMPANY_STATUS_ID,
    subTitle: REPLIED_COMPANY_STATUS_LABEL,
    Icon: MessageCircleIcon,
    iconBgColor: colors.indigo[700],
  },
  {
    id: OVERDUE_COMPANY_STATUS_ID,
    status: OVERDUE_COMPANY_STATUS_ID,
    subTitle: OVERDUE_COMPANY_STATUS_LABEL,
    Icon: AlertTriangleIcon,
    iconBgColor: colors.orange[700],
  },
  {
    id: CANCELED_STATUS_ID,
    status: CANCELED_COMPANY_STATUS_ID,
    subTitle: CANCELED_COMPANY_STATUS_LABEL,
    Icon: XCircleIcon,
    iconBgColor: theme.palette.error.main,
  },
  {
    id: COMPLETED_STATUS_ID,
    status: FINALIZED_COMPANY_STATUS_ID,
    subTitle: FINALIZED_COMPANY_STATUS_LABEL,
    Icon: CheckCircleIcon,
    iconBgColor: theme.palette.success.main,
  },
]

const ALL_STATUS_LABELS = [
  NEW_STATUS_LABEL,
  PENDING_STATUS_LABEL,
  COMPLETED_STATUS_LABEL,
  CANCELED_STATUS_LABEL,
  AWAITING_CONFIRMATION_STATUS_LABEL,
  AWAITING_CONFIRMATION_LEGITIMACY_STATUS_LABEL,
  AWAITING_CONFIRMATION_IDENTITY_STATUS_LABEL,
  AWAITING_COMPANY_REPLY_STATUS_LABEL,
  AWAITING_REPLY_VALIDATION_STATUS_LABEL,
  REPLIED_STATUS_LABEL,
  REOPEN_STATUS_LABEL,
]

const STATUS_TRANSLATION_LABELS = {
  [PENDING_STATUS_ID]: PENDING_STATUS_LABEL,
  [REPLIED_STATUS_ID]: REPLIED_STATUS_LABEL,
  [COMPLETED_STATUS_ID]: COMPLETED_STATUS_LABEL,
  [CANCELED_STATUS_ID]: CANCELED_STATUS_LABEL,
}

const STATUS_CHIP_CLASSNAME = {
  [PENDING_STATUS_ID]: PENDING_COMPANY_STATUS_ID,
  [REPLIED_STATUS_ID]: REPLIED_COMPANY_STATUS_ID,
  [COMPLETED_STATUS_ID]: FINALIZED_COMPANY_STATUS_ID,
  [CANCELED_STATUS_ID]: CANCELED_COMPANY_STATUS_ID,
}

const MESSAGE_STATUS_BUTTON_ITEMS = [
  {
    id: NEW_STATUS_ID,
    name: NEW_STATUS_LABEL,
  },
  {
    id: PENDING_STATUS_ID,
    name: PENDING_STATUS_LABEL,
  },
  {
    id: COMPLETED_STATUS_ID,
    name: COMPLETED_STATUS_LABEL,
  },
  {
    id: CANCELED_STATUS_ID,
    name: CANCELED_STATUS_LABEL,
  },
  {
    id: AWAITING_CONFIRMATION_STATUS_ID,
    name: AWAITING_CONFIRMATION_STATUS_LABEL,
  },
  {
    id: AWAITING_CONFIRMATION_LEGITIMACY_STATUS_ID,
    name: AWAITING_CONFIRMATION_LEGITIMACY_STATUS_LABEL,
  },
  {
    id: AWAITING_CONFIRMATION_IDENTITY_STATUS_ID,
    name: AWAITING_CONFIRMATION_IDENTITY_STATUS_LABEL,
  },
  {
    id: AWAITING_COMPANY_REPLY_STATUS_ID,
    name: AWAITING_COMPANY_REPLY_STATUS_LABEL,
  },
  {
    id: AWAITING_REPLY_VALIDATION_STATUS_ID,
    name: AWAITING_REPLY_VALIDATION_STATUS_LABEL,
  },
  {
    id: REPLIED_STATUS_ID,
    name: REPLIED_STATUS_LABEL,
  },
  {
    id: REOPEN_STATUS_ID,
    name: REOPEN_STATUS_LABEL,
  },
]

const tickets = {
  ALL_STATUS_LABELS,
  AWAITING_COMPANY_REPLY_STATUS_ID,
  AWAITING_CONFIRMATION_IDENTITY_STATUS_ID,
  AWAITING_CONFIRMATION_LEGITIMACY_STATUS_ID,
  AWAITING_REPLY_VALIDATION_STATUS_ID,
  CANCELED_STATUS_ID,
  COMPLETED_STATUS_ID,
  MESSAGE_STATUS_BUTTON_ITEMS,
  MESSAGE_SYSTEM_AUTHOR,
  NEW_STATUS_ID,
  PENDING_STATUS_ID,
  REOPEN_STATUS_ID,
  REPLIED_STATUS_ID,
  STATUS_CHIP_CLASSNAME_FROM_LABELS,
  STATUS_CHIP_CLASSNAME,
  STATUS_TRANSLATION_LABELS,
  TICKET_TYPE,
  TITULAR_STATS_CARD_ITEMS,
  AWAITING_CONFIRMATION_STATUS_ID,
}

export default tickets
